import {
  Component,
  OnInit,
  Input,
  ViewChild
} from '@angular/core';
import { ɵc, EventService } from '@crystalui/angular-lightbox';
import { Icons } from '@vex/icons/icons';
import { AuthService } from '@vex/http-service/auth.service';
import { DateFormatPipe } from '@vex/pipes/date-format/date-format.pipe';
import { CloudConnectStateService } from '@vex/constants/cloud-connect-state';
import { MdePopoverTrigger } from '@material-extended/mde';
import { DependencyMapService } from '@vex/http-service/dependency-map.service';
import { ConfigurationSource } from '@vex/model/device';

@Component({
  selector: 'device-card-full-width',
  templateUrl: './device-card-full-width.component.html',
  styleUrls: ['./device-card-full-width.component.scss'],
  providers: [DateFormatPipe, ɵc, EventService]
})
export class DeviceCardFullWidthComponent extends Icons implements OnInit {
  @Input() device: any;
  @ViewChild('target', { static: false }) target: MdePopoverTrigger;
  providers: any[] = [];
  value: string = '';
  label: string = '';
  state: any = {};
  inventoryState: any = {};

  /** An explicit false means the device is inventory data only. */
  get managesConfiguration(): boolean {
    return this.device?.ManageConfiguration !== false;
  }

  // DeviceConnectivityStatus
  get showsConnectionDetails(): boolean {
    return this.managesConfiguration &&
      this.device?.ConfigurationSource !== ConfigurationSource.FileUpload;
  }

  constructor(
    private cloudConnectStateService: CloudConnectStateService,
    private dependencyMapService: DependencyMapService,
    private authService: AuthService
  ) {
    super();
  }

  showTooltip(value, label) {
    this.value = value;
    this.label = label;
  }

  isAccess(id) {
    return this.authService.getRights('ActionIds', id);
  }

  openDeviceDetails() {
    if (this.isAccess('675366e2ce0af7b4dfbeb438')) {
      let url = `/device/list?id=${this.device.Id}`;
      if (this.device.InventoryId) {
        url += `&inventoryId=${this.device.InventoryId}`;
      }
      window.open(url, '_blank');
    }
  }

  getState(state: number) {
    return this.cloudConnectStateService.getDeviceConnectivityStatus(state);
  }

  getInventoryState(state: number) {
    return this.cloudConnectStateService.getConfigurationState(state);
  }

  mapData() {
    this.device['provider'] = this.providers?.find((x) => x.Id == this.device.ProviderId)?.Name || '';
    this.device['createDate'] = this.device.CreatedDate ? this.device.CreatedDate : this.device.UpdatedDate;
    this.device['updateDate'] = this.device.UpdatedDate ? this.device.UpdatedDate : this.device.CreatedDate;
    this.device['createBy'] = this.device.CreatedBy || 'Not populated';
    this.device['updateBy'] = this.device.UpdatedBy || 'Not populated';
  }

  getProvider() {
    this.dependencyMapService.getDependencyMapsForSelect().subscribe(
      (response) => {
        this.providers = response;
        this.mapData();
      },
      (error) => {
      }
    );
  }
  
  ngOnInit(): void {
    if (this.managesConfiguration) {
      this.state = this.getState(this.device.DeviceConnectivityStatus);
      this.inventoryState = this.getInventoryState(this.device.ConfigurationState);
    }
    this.getProvider();
  }
}
